import { useMemo } from "react";
import { capitalize, FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import CategoryProfileSubtitle from "@pages/CategoryProfile/components/CategoryProfileSubtitle/CategoryProfileSubtitle";
import { LaunchRankingItem } from "@apiHooks/useCategoryProfileLaunches";
import "./LaunchesRankingList.styles.scss";

interface Props {
    title: string;
    tooltipText: string;
    items: LaunchRankingItem[];
    maxItems?: number;
}

const LaunchesRankingList: FCX<Props> = ({
    title,
    tooltipText,
    items,
    className,
}) => {
    const maxCount = useMemo(
        () => items.reduce((max, item) => Math.max(max, item.count), 0),
        [items],
    );

    return (
        <div className={cn("LaunchesRankingList", className)}>
            <CategoryProfileSubtitle tooltipText={tooltipText} tooltipStyle={{ maxWidth: 'max-content' }}>
                {title}
            </CategoryProfileSubtitle>

            <div className="LaunchesRankingList__body">
                <div className="LaunchesRankingList__period">past 12 months</div>
                <div className="LaunchesRankingList__rows">
                    {items.map(item => (
                        <div key={item.id} className="LaunchesRankingList__row">
                            <div className="LaunchesRankingList__bar">
                                <div
                                    className="LaunchesRankingList__bar-fill"
                                    style={{
                                        width: `${maxCount > 0 ? (item.count / maxCount) * 100 : 0}%`,
                                    }}
                                />
                                <span className="LaunchesRankingList__bar-name" title={item.name}>
                                    {capitalize(item.name)}
                                </span>
                            </div>
                            <div className="LaunchesRankingList__count">{item.count}</div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default LaunchesRankingList;
